import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import BookingSummary from "../components/BookingSummary";
import { advancereserveLocker, bulkLockerReserver, getTenantAndAssignmentSettings } from "../api/api";
import { getPathForNextPage, getUnitLabelParamsFromBool, handleBulkReservationPayment } from "../lib/Utils";
import { LOCAL_STORAGE, LOCKER_SLUG, LS_LOCKER_BANK_INFO, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS, USER_INFO, LS_BOOKING_TYPE, BULK_BOOKING } from "../assets/constants/BrowserStorageKeys";
import { getSecureItemFromSpecificStorage, storeSecureItemInSpecifiedStorage } from "../lib/BrowserStorageAccessMiddleware";
import { BOOKING_SUMMARY, LOCKER_SIZE_SELECTION, LOGIN, USER_ACCOUNT } from "../assets/constants/PageList";
import { POD_BANK_TYPE, TOAST_SUCCESS } from "../assets/constants/Constants";
import ShowToast from "../components/ToastComponent";
import CircularProgressLoader from "../components/CircularProgressLoader";
import { useTranslation } from "react-i18next";

const BookingSummaryPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const state = history.location?.state || {};
  const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
  const [is_state_gst , setIsStateGst] = React.useState(false);
  const [isConfirmingBooking, setIsConfirmingBooking] = React.useState(false);
  const isPodLockerType = String(lockerBankInfo?.LockerBankType).toLowerCase() === POD_BANK_TYPE;
  const tenantAndAssignmentSettings = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
  const isPricingEnabled = tenantAndAssignmentSettings?.is_pricing;
  const ClintRefLabel = tenantAndAssignmentSettings?.usecase_settings?.client_ref?.label;
  const ClintRefValue = tenantAndAssignmentSettings?.usecase_settings?.client_ref?.value;
  
  const {
    selectedLockers = [],
    lockerCurrency = "INR",
    bookingTimingObject = [],
    lockerBankId = null,
    assignmentSlug = null,
    locker_bank_slug = null,
    IsAdvanceBooking = false,
    lockerName = "",
  } = state;

  const resolvedCurrency =
    lockerCurrency && lockerCurrency !== "null"
      ? lockerCurrency
      : selectedLockers?.[0]?.currency || "INR";

useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await getTenantAndAssignmentSettings(lockerBankInfo?.id);
        if(response?.status === "success"){
          setIsStateGst(response?.data?.locker_bank?.is_state_gst);
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };
  
   fetchSettings();
  }, []);
      

  const handleEditSelection = () => {
    history.replace({
      pathname: getPathForNextPage(BOOKING_SUMMARY, LOCKER_SIZE_SELECTION),
      state: {
        ...state,
        selectedLockers,
      },
    });
  };

  const handleLockerBooking = async (lockers = null, total = null, finalGSTObject, clientRef = null) => {
    setIsConfirmingBooking(true);
    try {
    const finalLockers = lockers || selectedLockers;
    const isPodPricingDisabled = isPodLockerType && !isPricingEnabled;
    const finalTotal = isPodPricingDisabled ? 0 : (total ?? 0);

    let allocationData = [];

    if (finalLockers[0]?.selectedSlot && finalLockers[0]?.bookingSlots) {
      allocationData = finalLockers.map((locker) => ({
        door_size: locker.door_size,
        price: isPodPricingDisabled ? 0 : Number(locker?.selectedSlot?.price || 0),
        slot_id: locker?.selectedSlot?.id || null,
      }));
    } else {
      allocationData = finalLockers.map((locker) => ({
        door_size: locker.door_size,
        price: isPodPricingDisabled ? 0 : Number(locker.price || 0),
        slot_id: locker.slot_id || null,
      }));
    }


    const bookingObject = {
      ...(IsAdvanceBooking ? bookingTimingObject : {}),
      allocation_method: "automatic_allocation",
      allocation_data: allocationData,
      total_price: finalTotal,
      client_ref: clientRef,
      locker_bank_id: lockerBankId,
      locker_bank_slug: locker_bank_slug
        ? locker_bank_slug
        : getSecureItemFromSpecificStorage(LOCAL_STORAGE, LOCKER_SLUG),
      assignmentSlug: assignmentSlug,
    };

    const userData = await getSecureItemFromSpecificStorage(
      LOCAL_STORAGE,
      USER_INFO
    );

    if (userData) {
      if (IsAdvanceBooking) {
        try {
          const reserveLockerResponse = await advancereserveLocker(bookingObject);
          if (reserveLockerResponse?.data?.status === "success") {
            if (!isPricingEnabled) {
              ShowToast(t('msg_success_locker_reservation_redirect_to_profile'), TOAST_SUCCESS);
              history.push(getPathForNextPage(BOOKING_SUMMARY, USER_ACCOUNT));
            } else {
              ShowToast(t('msg_success_Locker_reserved_wait_for_payment', getUnitLabelParamsFromBool(isPodLockerType, t)), TOAST_SUCCESS);
              await handleBulkReservationPayment(reserveLockerResponse, history, finalGSTObject, { isAdvanceBooking: true });
            }
          }
        } catch (error) {
          console.error("error happend during advance bokking", error)
        }
      } else {
        const reserveLockerResponse = await bulkLockerReserver(bookingObject);
        await handleBulkReservationPayment(reserveLockerResponse, history, finalGSTObject, {
          isAdvanceBooking: IsAdvanceBooking,
        });
      }
    } else {
      if (!IsAdvanceBooking) {
        storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_BOOKING_TYPE, BULK_BOOKING);
      }
      history.push({
        pathname: getPathForNextPage(BOOKING_SUMMARY, LOGIN),
        state: {
          bookingObject,
          finalGSTObject,
        },
      });
    }
    } finally {
      setIsConfirmingBooking(false);
    }
  };

  return (
    <div className="booking-summary-page">
      <div className="locker-summary-container">
        {isConfirmingBooking && <CircularProgressLoader message={t('pleaseWaitText')} />}
        <BookingSummary
          lockerCurrency={resolvedCurrency}
          bookingLockerHandler={handleEditSelection}
          selectedLockers={selectedLockers}
          handleLockerBooking={handleLockerBooking}
          is_state_gst={is_state_gst}
          isPodLockerType={isPodLockerType}
          bookingTimingObject={bookingTimingObject}
          lockerName={lockerName}
          clientRefLabel={ClintRefLabel}
          clientRefValue={ClintRefValue}
        />
      </div>
    </div>
  );
};

export default BookingSummaryPage;
